import { AbstractModalService } from '@/core/modals/AbstractModalService';
import { ModalOptions } from '@/core/modals/ModalState';
import { FacetViewObject, MenuItem } from '@/types/apiServerContract';

class MobileNavigationAndFacetsOverlayService extends AbstractModalService {
    public show(
        contextKey: string,
        initialFacets: FacetViewObject[] | null,
        rootMenuItem: MenuItem | null,
        activeMenuItem: MenuItem | null,
        campaignCode: string,
        menuItems: readonly MenuItem[],
        useFlattenedCategoryTree: boolean,
        options?: Partial<ModalOptions>
    ) {
        return this.showModal({
            component: () => import(
                /* webpackPrefetch: true */
                '@/project/search/navigation/MobileNavigationAndFacetsOverlay.vue'),
            componentAttrs: {
                contextKey,
                initialFacets,
                rootMenuItem,
                activeMenuItem,
                campaignCode,
                menuItems,
                useFlattenedCategoryTree
            },
            options: {
                placement: 'right',
                usePanelWrapper: false,
                closeOnRouteChange: true,
                closeOnBreakpointChange: true,
                contentMaxHeight: false,
                ...options
            }
        });
    }
}

export default new MobileNavigationAndFacetsOverlayService();
